




























import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { Component } from 'vue-property-decorator';
import { MswAppTitle } from '@/shared/msw-app-title';
import { SwTabGroup, SwTabPage, TabProps } from '@sonicwall/unified-ui-framework/src/shared/sw-tab-layout';
import { confirmService, ConfirmOptions } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';

const cssPrefix = 'swTools';

@Component({
  components: {
    ...UUIFComponents,
    MswAppTitle,
    SwTabGroup,
    SwTabPage,
  },
})
export default class SwTools extends SwExtendedVue {
  cssPrefix = cssPrefix;

  selectedTabId: string = 'tab1';
  userId: any = this.$store.getters.getUserId;
  migrationToolURL: string = `https://migratetool.global.sonicwall.com/?src=MSW&uname=${this.userId}`;
  swarmReportURL: string = `https://swarm.global.sonicwall.com/index.html?uname=${this.userId}`;
  basicTabsProps: TabProps[] = [
    {
      tabId: 'tab1',
      label: this.$t('swtool.migrationtool')
      .toString(),
    },
    {
      tabId: 'tab2',
      label: this.$t('swtool.swarmreport')
      .toString(),
    },
  ];
  get isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }
  openInNewTab(link: string) {
    const options: ConfirmOptions = {
      status: 'informational',
      message: 'You will be redirected to a new tab. Are you sure you want to continue ?',
      buttons: [{
        key: 'yes',
        name: this.$t('common.yes')
        .toString(),
        isDefault: true,
      }, {
        key: 'cancel',
        name: this.$t('common.cancel')
        .toString(),
        isDefault: false,
      }],
    };
    confirmService.confirm(options)
      .then((key) => {
        if (key === 'yes') {
          window.open(link, '_blank');
        }
      });
  }
  onSelectTab(tabId: string) {
    console.warn(tabId);
    this.selectedTabId = tabId;
  }
}
